/*
 * Monta NL: bezorgdag-teksten ("Vóór 23:45 besteld, morgen in huis").
 * Wordt alleen geladen in markt Netherlands met settings.monta_nl_mode == 'aan' (snippets/monta-nl-eta.liquid).
 * Rekent altijd in Europe/Amsterdam-tijd. Zonder dit script blijven de huidige teksten staan.
 *
 * Verwerkingsdag: vandaag als het ma-vr vóór de besteltijd is (cutoff, nu 23:30) of zaterdag vóór de zaterdagtijd
 * (cutoffSat, nu 16:00), en geen feestdag; anders de eerstvolgende zo'n dag (Monta, Frank 13-10: zaterdag tot 16:00,
 * daarna en op zondag wordt maandag verzonden).
 * Bezorgdag: eerste di-za na de verwerkingsdag die geen feestdag is (geen maandagbezorging aangenomen).
 * "Morgen" alleen als de verwerkingsdag vandaag is én de bezorgdag morgen.
 * Zaterdag vóór de zaterdagtijd: "vandaag verzonden" (geen bezorgdag beloofd).
 *
 * Plekken (data-monta-nl-eta):
 *   bar  - aankondigingsbalk, verzendslide: tekst 'bar' als vandaag ma-vr (geen feestdag) is en morgen een bezorgdag; anders de huidige tekst
 *   pdp  - productpagina, vervangt de klok: 'countdown', 'countdown_today' (zaterdag) of 'later'; geen regel als de gekozen variant niet beschikbaar is of niet verzonden wordt
 *   cart - cart drawer, regel onder het totaal: 'short', 'short_today' (zaterdag) of 'later'
 *   list - productpagina, lijst boven ADD TO CART (snippets/sava-ship-list.liquid, Tristan 13-10): voorraad + dagtekst.
 *          Voorraadregel: 'bijna uitverkocht' als de voorraad onder de drempel van het voorraadblok van dat product
 *          ligt (data-low-threshold, zelfde regel als live), anders 'op voorraad'.
 *   swap - hero-chip, Bestsellers-regel, USP-balk: data-alt ('morgen in huis') alleen als die belofte nu klopt
 *          (vandaag verzonden én morgen bezorgd); anders de bestaande tekst ('gratis verzending vanaf €70').
 */
(function () {
  'use strict';

  var cfgEl = document.getElementById('monta-nl-eta-config');
  if (!cfgEl || window.MontaNlEta) return;

  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }

  var TZ = 'Europe/Amsterdam';
  var cutoffMatch = /^(\d{1,2}):(\d{2})$/.exec(String(cfg.cutoff || '').trim());
  if (!cutoffMatch || !cfg.t) return;
  var cutoffSec = parseInt(cutoffMatch[1], 10) * 3600 + parseInt(cutoffMatch[2], 10) * 60;
  var satMatch = /^(\d{1,2}):(\d{2})$/.exec(String(cfg.cutoffSat || '').trim());
  // 0 = geen zaterdagverzending (lege of ongeldige instelling): dan gedraagt zaterdag zich als zondag
  var cutoffSatSec = satMatch ? parseInt(satMatch[1], 10) * 3600 + parseInt(satMatch[2], 10) * 60 : 0;

  var holidays = {};
  String(cfg.holidays || '').split(',').forEach(function (d) {
    d = d.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(d)) holidays[d] = true;
  });

  var partsFormat = new Intl.DateTimeFormat('en-GB', {
    timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  var lang = cfg.lang || 'en';
  var dayFormat;
  try {
    dayFormat = new Intl.DateTimeFormat(lang, { weekday: 'long', timeZone: TZ });
  } catch (e) {
    dayFormat = new Intl.DateTimeFormat('en', { weekday: 'long', timeZone: TZ });
  }
  var lowerDay = /^(nl|fr|es|it)/.test(lang);

  function nowInAmsterdam() {
    var p = {};
    partsFormat.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return {
      y: +p.year, m: +p.month, d: +p.day,
      sec: (+p.hour % 24) * 3600 + (+p.minute) * 60 + (+p.second)
    };
  }

  // Kalenderdag als Date op 12:00 UTC: valt in Amsterdam altijd op dezelfde datum.
  function calendarDay(y, m, d) { return new Date(Date.UTC(y, m - 1, d, 12)); }
  function addDays(date, n) { return new Date(date.getTime() + n * 86400000); }
  function dayKey(date) { return date.toISOString().slice(0, 10); }
  function isHoliday(date) { return holidays[dayKey(date)] === true; }
  function isWorkday(date) { var w = date.getUTCDay(); return w >= 1 && w <= 5 && !isHoliday(date); }
  function isDeliveryDay(date) { var w = date.getUTCDay(); return w >= 2 && w <= 6 && !isHoliday(date); }
  function isSaturday(date) { return date.getUTCDay() === 6; }
  function isShipDay(date) { return isWorkday(date) || (cutoffSatSec > 0 && isSaturday(date) && !isHoliday(date)); }
  function cutoffFor(date) { return isSaturday(date) ? cutoffSatSec : cutoffSec; }
  function nextMatching(date, test) {
    for (var i = 0; i < 60 && !test(date); i++) date = addDays(date, 1);
    return date;
  }

  function computeState() {
    var now = nowInAmsterdam();
    var today = calendarDay(now.y, now.m, now.d);
    var tomorrow = addDays(today, 1);
    var shipToday = isShipDay(today) && now.sec < cutoffFor(today);
    var processing = shipToday ? today : nextMatching(addDays(today, 1), isShipDay);
    var delivery = nextMatching(addDays(processing, 1), isDeliveryDay);
    var dayName = dayFormat.format(delivery);
    if (lowerDay) dayName = dayName.toLowerCase();
    return {
      tomorrow: shipToday && dayKey(delivery) === dayKey(tomorrow),
      today: shipToday && isSaturday(today),
      bar: isWorkday(today) && isDeliveryDay(tomorrow),
      remaining: Math.max(0, cutoffFor(today) - now.sec),
      dayName: dayName
    };
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function hms(total) {
    return pad(Math.floor(total / 3600)) + ':' + pad(Math.floor((total % 3600) / 60)) + ':' + pad(total % 60);
  }
  // De teksten komen HTML-veilig uit Liquid; tijd en dagnaam bevatten alleen cijfers, ':' en letters.
  function fill(template, vars) {
    return String(template).replace(/\[\[(\w+)\]\]/g, function (all, k) {
      return Object.prototype.hasOwnProperty.call(vars, k) ? vars[k] : all;
    });
  }
  function setHtml(el, html) {
    if (el.__montaNlHtml !== html) {
      el.innerHTML = html;
      el.__montaNlHtml = html;
    }
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function show(el, visible) {
    var value = visible ? '' : 'none';
    if (el.style.display !== value) el.style.display = value;
  }

  function variantShips(el) {
    var map;
    try { map = JSON.parse(el.getAttribute('data-variants') || '{}'); } catch (e) { return false; }
    var form = document.getElementById(el.getAttribute('data-form-id'));
    var input = form && form.querySelector('input[name="id"]');
    var id = input ? input.value : el.getAttribute('data-variant');
    return map[id] === 1;
  }

  function update() {
    var s = computeState();
    var later = fill(cfg.t.later, { day: s.dayName });

    document.querySelectorAll('[data-monta-nl-eta="bar"]').forEach(function (el) {
      var target = el.querySelector('p') || el;
      if (target.__montaNlOriginal === undefined) target.__montaNlOriginal = target.innerHTML;
      setHtml(target, s.bar ? cfg.t.bar : target.__montaNlOriginal);
    });

    document.querySelectorAll('[data-monta-nl-eta="pdp"]').forEach(function (el) {
      var original = el.previousElementSibling;
      if (original && original.classList.contains('product__countdown-timer')) {
        original.classList.add('monta-nl-eta-hide');
      }
      var ships = variantShips(el);
      var text = el.querySelector('[data-monta-nl-eta-text]');
      if (ships && text) {
        var timeHtml = '<span class="monta-nl-eta__time">' + hms(s.remaining) + '</span>';
        setHtml(text, s.tomorrow
          ? fill(cfg.t.countdown, { time: timeHtml })
          : (s.today && cfg.t.countdown_today ? fill(cfg.t.countdown_today, { time: timeHtml }) : later));
      }
      show(el, ships && !!text);
    });

    // List above ADD TO CART (snippets/sava-ship-list.liquid): stock of the selected variant + delivery day.
    document.querySelectorAll('[data-monta-nl-eta="list"]').forEach(function (el) {
      var original = el.previousElementSibling;
      if (original && original.classList.contains('product__countdown-timer')) {
        original.classList.add('monta-nl-eta-hide');
      }
      var map, t;
      try {
        map = JSON.parse(el.getAttribute('data-variants') || '{}');
        t = JSON.parse(el.getAttribute('data-text') || '{}');
      } catch (e) { show(el, false); return; }
      var form = document.getElementById(el.getAttribute('data-form-id'));
      var input = form && form.querySelector('input[name="id"]');
      var v = map[input ? input.value : el.getAttribute('data-variant')];
      var ships = !!v && v[0] === 1;
      var threshold = parseInt(el.getAttribute('data-low-threshold') || '0', 10) || 0;
      if (ships) {
        var qty = v[1];
        var low = threshold > 0 && typeof qty === 'number' && qty < threshold;
        var stockRow = el.querySelector('[data-sava-ship-stock]');
        var stockText = el.querySelector('[data-sava-ship-stock-text]');
        if (stockRow) stockRow.classList.toggle('is-low', low);
        if (stockText) setHtml(stockText, low ? fill(t.lowStock, { count: String(qty) }) : t.inStock);
        var eta = el.querySelector('[data-monta-nl-eta-text]');
        if (eta) {
          setHtml(eta, s.tomorrow
            ? fill(t.tomorrow, { cutoff: String(cfg.cutoff) })
            : (s.today && cfg.cutoffSat ? fill(t.today, { cutoff: String(cfg.cutoffSat) }) : fill(t.later, { day: s.dayName })));
        }
      }
      show(el, ships);
    });

    document.querySelectorAll('[data-monta-nl-eta="swap"]').forEach(function (el) {
      if (el.__montaNlOriginal === undefined) el.__montaNlOriginal = el.innerHTML;
      setHtml(el, s.tomorrow ? escapeHtml(el.getAttribute('data-alt') || '') : el.__montaNlOriginal);
    });

    document.querySelectorAll('[data-monta-nl-eta="cart"]').forEach(function (el) {
      var text = el.querySelector('[data-monta-nl-eta-text]');
      if (!text) return;
      setHtml(text, s.tomorrow ? cfg.t.short : (s.today && cfg.t.short_today ? cfg.t.short_today : later));
      show(el, true);
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; update(); });
  }

  window.MontaNlEta = { update: update, state: computeState };
  update();
  setInterval(update, 1000);
  // Cart drawer en productblokken worden soms opnieuw gerenderd: nieuwe elementen meteen invullen.
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1 && (node.matches('[data-monta-nl-eta]') || node.querySelector('[data-monta-nl-eta]'))) {
          schedule();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('change', schedule, true);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, schedule);
  }
})();
